import { ClassValue } from 'clsx';
import { PropsWithChildren } from 'react';

import { Icon } from '@shared/ui/components/Icon';
import { IconType } from '@shared/ui/components/Icon';
import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

type PortletProps = PropsWithClassName<
  PropsWithChildren<{
    title?: string;
    icon?: IconType;
    innerClassName?: ClassValue;
    actions?: React.ReactNode;
  }>
>;

export function Portlet({
  title,
  icon,
  className,
  innerClassName,
  children,
  actions,
}: PropsWithChildren<PortletProps>) {
  return (
    <section className={cn('bg-white shadow-lg', className)}>
      {(title || actions) && (
        <header className="p-8 border-b flex flex-wrap items-center gap-4">
          {icon && <Icon icon={icon} className="text-3xl text-gray-500" />}
          <h4 className="text-xl font-medium text-gray-500">{title}</h4>
          <div className="w-full mt-4 grid gap-3 sm:ml-auto sm:w-auto sm:flex sm:flex-wrap sm:mt-0">{actions}</div>
        </header>
      )}
      <div className={cn('p-8', innerClassName)}>{children}</div>
    </section>
  );
}
